import angular from 'angular';

module.exports = angular.module('market.deprecated', [
  require('./neighborhood-map.js'),
  require('./od-headline.js'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/deprecated/index.js
 **/